import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import PageTitle from '../Common/PageTitle';
import { getBaseUrl } from '../../utils';
import { getUserData } from '../../api/auth';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    total: {
        margin: '10px 0px',
        padding: '10px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.light,
    },
    question: {
        width: '100%',
        margin: '10px 0px',
        padding: '10px',
        backgroundColor: theme.palette.secondary.main,
    },
    icon: {
        marginRight: theme.spacing.unit,
    },
});

interface Props extends RouteComponentProps<{ quizId: string; }> {
    getQuiz: (id: string) => any;
    getParticipate: (params: Bee.Params) => any;
    classes: {
        container: string;
        total: string;
        question: string;
        icon: string;
    };
}

interface State {
    quiz: Bee.Quiz | null;
    score: number;
}

class Score extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            score: 0,
            quiz: null,
        }
    }

    componentDidMount() {
        this.onMount();
    }

    private onMount = async () => {
        await this.getParticipate();
        await this.getQuiz();
    }

    private getQuiz = async () => {
        const data = await this.props.getQuiz(this.props.match.params.quizId);
        if (data) {
            this.setState({ quiz: data });
        }
    }

    private getParticipate = async () => {
        const data = await this.props.getParticipate({
            quizId: this.props.match.params.quizId,
            username: getUserData().username,
        });
        if (data && data.count > 0) {
            const score = data.results[0].score;
            if (score) {
                this.setState({ score });
            }
        }
    }

  	render() {
        const { classes } = this.props;
        const { quiz } = this.state;

        if(!quiz) {
            return <Typography variant="h5" align="center">No Quiz Found</Typography>
        }

        if (!quiz.answers) {
            return <Typography variant="h5" align="center">This quiz is still active, no score available yet</Typography>
        }

        return (
            <div className={classes.container}>
                <PageTitle title={quiz.title} back={`${getBaseUrl(this.props.match.path)}${this.props.location.hash}`} />
                <Card className={classes.total}>
                    <Typography color="inherit" variant="h5" align="center">{`Your Score: ${this.state.score}`}</Typography>
                </Card>
                {quiz.answers.map((ans, ix) => (
                    <Card key={ans.correctOption} className={classes.question}>
                        <Typography variant="h6" gutterBottom align="center">
                            {`Question ${ix + 1}`}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom align="center">{`Answer: ${ans.correctOption}`}</Typography>
                        <Typography variant="subtitle2" gutterBottom align="center">Explanation:</Typography>
                        <Typography variant="caption" align="center">
                            {ans.description}
                        </Typography>
                    </Card>
                ))}
            </div>
        );
	}
}

export default withStyles(jss)(Score);



// WEBPACK FOOTER //
// ./src/components/Score/Score.tsx